
import React, {
  PropTypes
} from 'react';

import {
  Nav, NavItem,
  Navbar
} from 'react-bootstrap';

import { animateScroll } from 'react-scroll';

import app from '../../app_data/index';

import Brand from './Brand';
import './index.css';

const onSelectHandler = ({ name, link }) => {
  const element = document.getElementById(name);

  const external = link.external;

  switch (true) {
  case link.scroll:
    const pos = element.offsetTop;
    animateScroll.scrollTo(pos - 50, {
      duration: 640,
      // delay: 100,
      // smooth: true
    });

    // ... no animation
    // window.scrollTo(0, pos - 50);
    break;

  case link.hashRouter:
    // This mess...
    // Dev: / => /#/name
    // Prod: /some-path then => /some-path/#/name
    // Decide if it's necessary to append a backslash to the base path
    const deployPath = app.deployPath;
    const actual = deployPath === '/' ? deployPath : `${deployPath}/`;
    window.location.assign(`${actual}#/${name}`);
    break;

  case !!external:
    window.open(external, '_blank');
    break;

  default:
    throw Error(`... invalid link for '${name}'`);
  }
};

const NavBar = ({ scrolledPastLimit, appData }) => {
  const navClass = scrolledPastLimit ? 'default_height' : 'tall';

  return (
    <Navbar
      inverse collapseOnSelect fixedTop role="navigation"
      id="nav_bar"
      className={ `nav_bar + ${navClass}` }
      fluid
    >
      <Navbar.Header>
        <Brand appData={appData} />
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse id="collapse">
        <Nav pullRight id="right">
          {
            appData.navItems.map((navItem, ix) => (
              <NavItem
                key={ix}
                eventKey={ix}
                onSelect={() => { onSelectHandler(navItem); }}
              >
                {navItem.title}
              </NavItem>
            ))
          }
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

NavBar.propTypes = {
  scrolledPastLimit: PropTypes.bool,
  appData: PropTypes.shape().isRequired
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/nav_bar/index.js